module.exports = __webpack_public_path__ + "static/media/illo_audio.7dc61c4f.svg";